import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "./index.css";
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Container } from '@design-system/container';
import { RetailersBlock } from '@design-system/retailers-block';
import { Section } from '@design-system/section';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { useMemo, useCallback, forwardRef } from 'react';
import { Carousel } from '@design-system/carousel';
import { Breadcrumbs } from '@design-system/breadcrumbs';
import { BazaarRatingSummary } from '@phx-husky/bazaarvoice-components';
import { Link } from '@design-system/link';
import { Button } from '@design-system/button';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var CarouselBlock = function CarouselBlock(_a) {
  var imageElements = _a.imageElements,
    buttonPrev = _a.buttonPrev,
    buttonNext = _a.buttonNext,
    _a$variant = _a.variant,
    variant = _a$variant === void 0 ? 'single' : _a$variant,
    _a$progressIndicator = _a.progressIndicator,
    progressIndicator = _a$progressIndicator === void 0 ? 'none' : _a$progressIndicator,
    carouselProps = __rest(_a, ["imageElements", "buttonPrev", "buttonNext", "variant", "progressIndicator"]);
  return jsx(Carousel, Object.assign({
    items: imageElements.map(function (el) {
      return {
        children: el
      };
    }),
    variant: variant,
    progressIndicator: progressIndicator,
    buttonPrev: buttonPrev,
    buttonNext: buttonNext
  }, carouselProps));
};
var HeadingBlock = function HeadingBlock(_ref) {
  var heading = _ref.heading,
    subHeading = _ref.subHeading,
    description = _ref.description,
    breadcrumbs = _ref.breadcrumbs,
    productId = _ref.productId;
  return jsxs("div", Object.assign({
    className: "cds-product-page-header__heading"
  }, {
    children: [breadcrumbs && jsx(Breadcrumbs, Object.assign({
      className: "cds-product-page-header__breadcrumbs"
    }, breadcrumbs)), productId ? jsx(BazaarRatingSummary, {
      productId: productId
    }) : null, jsxs("h1", Object.assign({
      className: "cds-product-page-header__title"
    }, {
      children: [jsx(Typography, {
        content: heading,
        weight: "bold",
        variant: "headline",
        size: "xl",
        tag: "span"
      }), subHeading && jsxs(Fragment, {
        children: [jsx("span", Object.assign({
          className: "cds-product-page-header__hidden-space"
        }, {
          children: "\xA0"
        })), jsx(Typography, {
          className: "cds-product-page-header__sub-heading",
          content: subHeading,
          variant: "overline",
          tag: "span"
        })]
      })]
    })), description && jsx(Typography, {
      className: "cds-product-page-header__description",
      content: description,
      variant: "body",
      size: "m",
      tag: "p"
    })]
  }));
};
var checkIsFallBack = function checkIsFallBack(variants) {
  var fallBackObj = variants.reduce(function (prev, current) {
    var dimension1 = current.dimension1,
      dimension2 = current.dimension2;
    return Object.assign(Object.assign({}, prev), _defineProperty({}, dimension2, Object.assign(Object.assign({}, prev[dimension2]), _defineProperty({}, dimension1, true))));
  }, {});
  var fallBackArr = Object.keys(fallBackObj).map(function (key) {
    var restDimensions = Object.keys(fallBackObj).reduce(function (prev, current) {
      if (key === current) return Object.assign({}, prev);
      return Object.assign(Object.assign({}, prev), fallBackObj[current]);
    }, {});
    return !Object.keys(fallBackObj[key]).some(function (el) {
      return restDimensions[el];
    });
  });
  return fallBackArr.some(Boolean);
};
var normalizeDimensions = function normalizeDimensions(variants) {
  return variants.reduce(function (prev, current) {
    var _prev = _slicedToArray(prev, 2),
      first = _prev[0],
      second = _prev[1];
    var dimension1 = current.dimension1,
      dimension2 = current.dimension2;
    return [Object.assign(Object.assign({}, first), _defineProperty({}, dimension1, [].concat(_toConsumableArray(first[dimension1] || []), [current]))), Object.assign(Object.assign({}, second), _defineProperty({}, dimension2, [].concat(_toConsumableArray(second[dimension2] || []), [current])))];
  }, [{}, {}]);
};
var useVariants = function useVariants(_ref2) {
  var currentDimension1 = _ref2.currentDimension1,
    currentDimension2 = _ref2.currentDimension2,
    variants = _ref2.variants;
  var isOneDimension = useMemo(function () {
    return !currentDimension2 || !variants.every(function (_ref3) {
      var dimension2 = _ref3.dimension2;
      return dimension2;
    });
  }, [variants, currentDimension2]);
  var isFallBack = useMemo(function () {
    if (isOneDimension) return false;
    return checkIsFallBack(variants);
  }, [isOneDimension, variants]);
  var prepareDimensions = useCallback(function () {
    var _normalizeDimensions = normalizeDimensions(variants),
      _normalizeDimensions2 = _slicedToArray(_normalizeDimensions, 2),
      resultDimension1 = _normalizeDimensions2[0],
      resultDimension2 = _normalizeDimensions2[1];
    var availableDimension1 = resultDimension2[currentDimension2];
    var availableDimension2 = resultDimension1[currentDimension1];
    var result1 = _toConsumableArray(availableDimension1);
    var result2 = _toConsumableArray(availableDimension2);
    Object.keys(resultDimension1).forEach(function (key) {
      var check = availableDimension1.some(function (_ref4) {
        var dimension1 = _ref4.dimension1;
        return key === dimension1;
      });
      if (!check) {
        result1.push({
          dimension1: key,
          disabled: true
        });
      }
    });
    Object.keys(resultDimension2).forEach(function (key) {
      var check = availableDimension2.some(function (_ref5) {
        var dimension2 = _ref5.dimension2;
        return key === dimension2;
      });
      if (!check) {
        result2.push({
          dimension1: '',
          dimension2: key,
          disabled: true
        });
      }
    });
    return {
      dimension1: result1,
      dimension2: result2
    };
  }, [currentDimension1, currentDimension2, variants]);
  var createFallbackArr = useCallback(function () {
    return variants.map(function (_ref6) {
      var dimension1 = _ref6.dimension1,
        dimension2 = _ref6.dimension2,
        href = _ref6.href;
      return {
        dimension1: "".concat(dimension1, " ").concat(dimension2),
        dimension2: '',
        href: href
      };
    });
  }, [variants]);
  var _useMemo = useMemo(function () {
      if (isFallBack) {
        var dimension1 = createFallbackArr();
        return [dimension1, null];
      }
      if (!isOneDimension && !isFallBack) {
        var _prepareDimensions = prepareDimensions(),
          _dimension = _prepareDimensions.dimension1,
          dimension2 = _prepareDimensions.dimension2;
        return [_dimension, dimension2];
      }
      return [variants, null];
    }, [createFallbackArr, isFallBack, isOneDimension, prepareDimensions, variants]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    dimension1Arr = _useMemo2[0],
    dimension2Arr = _useMemo2[1];
  return [dimension1Arr, dimension2Arr];
};
var VariantSelector = function VariantSelector(_ref7) {
  var labelDimension1 = _ref7.labelDimension1,
    labelDimension2 = _ref7.labelDimension2,
    currentDimension1 = _ref7.currentDimension1,
    currentDimension2 = _ref7.currentDimension2,
    variants = _ref7.variants,
    _ref7$linkComponent = _ref7.linkComponent,
    LinkComponent = _ref7$linkComponent === void 0 ? Link : _ref7$linkComponent;
  var _useVariants = useVariants({
      currentDimension1: currentDimension1,
      currentDimension2: currentDimension2,
      variants: variants
    }),
    _useVariants2 = _slicedToArray(_useVariants, 2),
    dimension1Arr = _useVariants2[0],
    dimension2Arr = _useVariants2[1];
  return jsxs("div", Object.assign({
    className: "cds-variant-selector"
  }, {
    children: [jsxs("div", Object.assign({
      className: classNames('cds-variant-selector__block', {
        'cds-variant-selector__block--one-dimension': !dimension2Arr
      })
    }, {
      children: [jsx(Typography, {
        id: "dimension1",
        content: labelDimension1,
        variant: "body",
        size: "s",
        tag: "p"
      }), jsx("ul", Object.assign({
        "aria-labelledby": "dimension1",
        className: "cds-variant-selector__list"
      }, {
        children: dimension1Arr.map(function (_ref8) {
          var href = _ref8.href,
            dimension1 = _ref8.dimension1,
            disabled = _ref8.disabled;
          var isActive = currentDimension1 === dimension1 || "".concat(currentDimension1, " ").concat(currentDimension2) === dimension1;
          return jsx("li", {
            children: disabled ? jsx("a", Object.assign({
              role: "link",
              "aria-disabled": "true",
              className: "cds-variant-selector__disabled-option"
            }, {
              children: dimension1
            })) : jsx(LinkComponent, Object.assign({
              className: isActive ? 'active' : undefined,
              variant: "selector",
              href: href
            }, isActive ? {
              'aria-current': true
            } : {}, {
              children: dimension1
            }))
          }, href || dimension1);
        })
      }))]
    })), labelDimension2 && !!dimension2Arr && jsxs("div", Object.assign({
      className: "cds-variant-selector__block"
    }, {
      children: [jsx(Typography, {
        id: "dimension2",
        content: labelDimension2,
        variant: "body",
        size: "s",
        tag: "p"
      }), jsx("ul", Object.assign({
        "aria-labelledby": "dimension2",
        className: "cds-variant-selector__list"
      }, {
        children: dimension2Arr.map(function (_ref9) {
          var href = _ref9.href,
            dimension2 = _ref9.dimension2,
            disabled = _ref9.disabled;
          return jsx("li", {
            children: disabled ? jsx("a", Object.assign({
              role: "link",
              "aria-disabled": "true",
              className: "cds-variant-selector__disabled-option"
            }, {
              children: dimension2
            })) : jsx(LinkComponent, Object.assign({
              className: currentDimension2 === dimension2 ? 'active' : undefined,
              variant: "selector",
              href: href
            }, currentDimension2 === dimension2 ? {
              'aria-current': true
            } : {}, {
              children: dimension2
            }))
          }, href || dimension2);
        })
      }))]
    }))]
  }));
};
var WhereToBuy = function WhereToBuy(_ref10) {
  var barcodeNumber = _ref10.barcodeNumber,
    isPriceSpiderAvailable = _ref10.isPriceSpiderAvailable,
    isAdimoAvailable = _ref10.isAdimoAvailable,
    adimoKey = _ref10.adimoKey,
    adimoButton = _ref10.adimoButton,
    shoppableInformationText = _ref10.shoppableInformationText,
    isMikMakAvailable = _ref10.isMikMakAvailable,
    mikmakAppId = _ref10.mikmakAppId,
    mikmakButton = _ref10.mikmakButton;
  var isAdimo = isAdimoAvailable && adimoKey;
  var isPriceSpider = isPriceSpiderAvailable && barcodeNumber;
  var isMikMak = isMikMakAvailable && mikmakAppId;
  return jsxs(Fragment, {
    children: [shoppableInformationText && (isAdimo || isMikMak || isPriceSpider) && jsxs(Container, Object.assign({
      maxWidth: "max-grid",
      className: "cds-product-page-header__shoppable-information"
    }, {
      children: [jsx(Typography, {
        content: shoppableInformationText,
        variant: "body",
        size: "xs",
        weight: "medium",
        tag: "p"
      }), isAdimo ? jsx(Button, Object.assign({
        variant: "primary",
        size: "large",
        className: "adimo-site-product-first",
        "data-type": "site-product-first",
        "data-static-touchpoint-identifier": adimoKey
      }, {
        children: adimoButton
      })) : null, isMikMak ? jsx(Button, Object.assign({
        variant: "primary",
        size: "large",
        className: "swn-tag-wtb-btn",
        "data-eans": barcodeNumber
      }, {
        children: mikmakButton
      })) : null, isPriceSpider ? jsx("div", {
        className: "cds-product-page-header__price-spider ps-widget",
        "ps-sku": barcodeNumber
      }) : null]
    })), !shoppableInformationText && isPriceSpider && jsx(Container, Object.assign({
      maxWidth: "max-grid",
      className: "cds-product-page-header__shoppable-information"
    }, {
      children: isPriceSpider ? jsx("div", {
        className: "cds-product-page-header__price-spider ps-widget",
        "ps-sku": barcodeNumber
      }) : null
    }))]
  });
};
var ProductPageHeader = forwardRef(function (_a, ref) {
  var mode = _a.mode,
    element = _a.element,
    className = _a.className,
    breadcrumbs = _a.breadcrumbs,
    heading = _a.heading,
    subHeading = _a.subHeading,
    description = _a.description,
    disclaimer = _a.disclaimer,
    retailersBlock = _a.retailersBlock,
    variantSelector = _a.variantSelector,
    carouselBlock = _a.carouselBlock,
    productId = _a.productId,
    shopifyBlockComponent = _a.shopifyBlockComponent,
    whereToBuyData = _a.whereToBuyData,
    htmlProperties = __rest(_a, ["mode", "element", "className", "breadcrumbs", "heading", "subHeading", "description", "disclaimer", "retailersBlock", "variantSelector", "carouselBlock", "productId", "shopifyBlockComponent", "whereToBuyData"]);
  return jsxs(Section, Object.assign({
    ref: ref,
    className: classNames('cds-product-page-header', className),
    removeAllSpacing: true,
    mode: mode,
    element: element
  }, htmlProperties, {
    children: [jsxs(Container, Object.assign({
      className: "cds-product-page-header__container",
      maxWidth: "max-grid"
    }, {
      children: [jsx(HeadingBlock, {
        breadcrumbs: breadcrumbs,
        heading: heading,
        subHeading: subHeading,
        description: description,
        productId: productId
      }), carouselBlock && jsx("div", Object.assign({
        className: "cds-product-page-header__media"
      }, {
        children: jsx(CarouselBlock, Object.assign({}, carouselBlock))
      })), variantSelector || retailersBlock ? jsxs("div", Object.assign({
        className: "cds-product-page-header__variants"
      }, {
        children: [variantSelector && jsx(VariantSelector, {
          labelDimension1: variantSelector.labelDimension1,
          labelDimension2: variantSelector.labelDimension2,
          currentDimension1: variantSelector.currentDimension1,
          currentDimension2: variantSelector.currentDimension2,
          variants: variantSelector.variants,
          linkComponent: variantSelector.linkComponent
        }), retailersBlock && jsx(RetailersBlock, {
          label: retailersBlock.label,
          retailerLinks: retailersBlock.retailerLinks,
          onClickRetailerName: retailersBlock.onClickRetailerName
        })]
      })) : null, shopifyBlockComponent]
    })), disclaimer && jsx(Container, Object.assign({
      maxWidth: "max-grid",
      className: "cds-product-page-header__disclaimer"
    }, {
      children: jsx(Typography, {
        content: disclaimer,
        variant: "body",
        size: "s",
        tag: "p"
      })
    })), whereToBuyData && jsx(WhereToBuy, Object.assign({}, whereToBuyData))]
  }));
});
export { ProductPageHeader };